// AI 봇 — docs/GAME_DESIGN.md 6장. 방장이 대기실의 빈 자리에 넣고, 서버가 사람 대신 조종한다.
// 난이도는 속임수(자원을 더 주기·안개 속 들여다보기) 없이 판단 속도와 목표치만 다르다.

export const BOT_LEVELS = Object.freeze({
  easy: Object.freeze({ id: 'easy', name: '쉬움', desc: '천천히 자라고 적은 병력으로 온다' }),
  normal: Object.freeze({ id: 'normal', name: '보통', desc: '농노를 꾸준히 늘리고 성채 시대에 병력을 모아 온다' }),
  hard: Object.freeze({ id: 'hard', name: '어려움', desc: '빠르게 판단하고 왕국 시대까지 올라 큰 병력으로 밀어붙인다' }),
});

export const BOT_LEVEL_IDS = Object.freeze(Object.keys(BOT_LEVELS));
export const DEFAULT_BOT_LEVEL = 'normal';

/** 봇 uid는 'bot:'으로 시작한다 (계정 uid와 겹치지 않는다) */
export const isBotUid = (uid) => typeof uid === 'string' && uid.startsWith('bot:');

/** 방에 보이는 봇 이름: "보통 봇 2" */
export const botName = (level, index) => `${(BOT_LEVELS[level] ?? BOT_LEVELS[DEFAULT_BOT_LEVEL]).name} 봇 ${index}`;
